import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

//Contact us - Get All (Read)
export const GetAll = createAsyncThunk(
  "contactuss/contactus/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Contactuss.ContactUs}?name=${filter?.name || ""}&whatsapp_no=${filter?.whatsapp_no || ""}&city=${filter?.city || ""}&pincode=${filter?.pincode || ""}&message=${filter?.message || ""}&privacy_policy=${filter?.privacy_policy || ""}&page=${filter?.page || IDS.PAGE
        }&per_page=${filter?.per_page || IDS.PERPAGE}`,
      );
      return res;
    } 
    catch (error) {
      return rejectWithValue(error.message);
    }
  },
);


//Contact us - Get (Read)
export const GetSingle = createAsyncThunk(
  "contactuss/contactus/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Contactuss.ContactUs}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);



//Contact us - Create (Add)
export const Create = createAsyncThunk(
  "contactuss/contactus/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Contactuss.ContactUs, data);
      return res; // The new object
    } 
    
    catch (error) {
      return rejectWithValue(error.message);
    }
  },
);


//Contact us - Update
export const Update = createAsyncThunk(
  "contactuss/contactus/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.Contactuss.ContactUs}/${id}`, data);
      return res;
    } 
    catch (error) {
      return rejectWithValue(error.message);
    }
  },
);



//Contact us - Delete
export const Delete = createAsyncThunk(
  "contactuss/contactus/delete",
  async (id, { rejectWithValue }) => {
    try {
      const data = await DELETE(`${APIS.Contactuss.ContactUs}/${id}`);
      return id; // Return the id of the deleted bill
    } 
    
    catch (error) {
      return rejectWithValue(error.message);
    }
  },
);


//Contact us - Status
export const StatusContactUs = createAsyncThunk(
  "contactuss/contactus/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Contactuss.ContactUs}/${id}`);
      return res;
    } 
    
    catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "contactus",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(GetAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSingle.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSingle.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetSingle.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })


      .addCase(Delete.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Delete.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
            (contactus) => contactus.id !== action.payload.id); // Remove with the deleted id
      })
      .addCase(Delete.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //
      .addCase(StatusContactUs.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusContactUs.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
            (contactus) => contactus.id !== action.payload.id); // Remove the with the deleted id
      })
      .addCase(StatusContactUs.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
